// src/scripts/fluco-lib/media-queries.js
function getMediaQuery(querySize, sectionElement) {
  const value = getComputedStyle(sectionElement).getPropertyValue(
    `--fluco-js-${querySize}`
  );
  if (!value) {
    console.warn("Invalid querySize passed to getMediaQuery");
    return false;
  }
  return value;
}
function checkMediaQuery(querySize, sectionElement) {
  const mediaQuery = getMediaQuery(querySize, sectionElement);
  return window.matchMedia(mediaQuery).matches;
}

// src/scripts/shared/fluco-shared-countdown-timer-group.js
var CountdownTimerGroup = class extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      sectionInner: "[js-section-inner]",
      activeContentBlock: "[js-active-content-block]",
      activeTimer: "[js-active-timer]",
      timerContainerDesktop: "[js-timer-container-desktop]",
      timerContainerMobile: "[js-timer-container-mobile]"
    };
  }
  connectedCallback() {
    const hasRepositioningTimers = this.getAttribute("data-has-repositioning-timers") === "true";
    if (hasRepositioningTimers === false) return;
    this.eventController = new AbortController();
    this.eventOptions = { signal: this.eventController.signal };
    this.sectionInnerEl = this.closest(this.selectors.sectionInner);
    window.requestAnimationFrame(this.setTimerPlacement.bind(this));
    window.addEventListener("resize", this.setTimerPlacement.bind(this), {
      passive: true,
      signal: this.eventController.signal
    });
  }
  disconnectedCallback() {
    this.eventController.abort();
  }
  setTimerPlacement() {
    this.activeContentBlock = this.querySelector(
      this.selectors.activeContentBlock
    );
    this.timerContainerDesktop = this.activeContentBlock.querySelector(
      this.selectors.timerContainerDesktop
    );
    this.timerContainerMobile = this.activeContentBlock.querySelector(
      this.selectors.timerContainerMobile
    );
    const activeTimer = this.activeContentBlock.querySelector(
      this.selectors.activeTimer
    );
    const isMobile = checkMediaQuery("mobile", this);
    let targetContainer;
    if (isMobile) {
      targetContainer = this.timerContainerMobile;
    } else {
      targetContainer = this.timerContainerDesktop;
    }
    if (activeTimer && targetContainer && activeTimer.parentNode !== targetContainer) {
      targetContainer.innerHTML = "";
      targetContainer.appendChild(activeTimer);
    }
  }
};
if (!customElements.get("fluco-shared-v6-countdown-timer-group")) {
  customElements.define(
    "fluco-shared-v6-countdown-timer-group",
    CountdownTimerGroup
  );
}
